import * as React from "react";

import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import usePlayer from "src/hooks/usePlayer";
import MaxLineText from "src/components/MaxLineText";
import LazySize from "src/components/LazySize";
import SvgIconStyle from "src/components/SvgIconStyle";

export default function EpisodeItem({ episode }) {
  const { logo, title, description } = episode;
  const { setVideoData } = usePlayer();

  return (
    <Card
      sx={{
        display: "flex",
        borderRadius: "8px",
        // height: { xs: 100, sm: "auto" },
        bgcolor: "secondary.dark",
      }}
    >
      <CardContent sx={{ p: { xs: 1, sm: 2 }, flexGrow: 1 }}>
        <MaxLineText
          maxLine={1}
          component="div"
          variant="h6"
          gutterBottom
          text={title}
        />
        <MaxLineText maxLine={3} variant="body1" text={description} />
      </CardContent>
      <CardMedia sx={{ p: 1 }}>
        <Box
          sx={{
            width: { xs: 125, sm: 255 },
            height: "100%",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%",
              "&:hover > .MuiBox-root": {
                display: "flex",
              },
            }}
          >
            <LazySize
              alt={title}
              src={logo}
              hidePlaceholder={true}
              sx={{
                borderRadius: { xs: "4px", md: "8px" },
              }}
            />
            <Box
              sx={{
                top: 0,
                width: 1,
                height: 1,
                borderRadius: { xs: "4px", sm: "8px" },
                position: "absolute",
                color: "common.white",
                display: { xs: "flex", sm: "none" },
                justifyContent: "center",
                alignItems: "center",
                backgroundImage: (theme) =>
                  `linear-gradient(to top, ${
                    theme.palette.grey[900]
                  } 0%,${alpha(theme.palette.grey[900], 0)} 100%)`,
              }}
            >
              <IconButton color="inherit" onClick={() => setVideoData(episode)}>
                <SvgIconStyle
                  src="/static/vectors/play.svg"
                  sx={{ width: 35, height: 35 }}
                />
              </IconButton>
            </Box>
            <Box
              sx={{
                bottom: { xs: 8, sm: 16 },
                right: { xs: 8, sm: 16 },
                position: "absolute",
                display: { xs: "flex", sm: "none" },
              }}
            >
              <Typography variant="caption">32mins</Typography>
            </Box>
          </Box>
        </Box>
      </CardMedia>
    </Card>
  );
}
